export default __webpack_public_path__ + "static/media/LB.8cb787e4.svg";